export default __webpack_public_path__ + "static/media/lib-8.5d82914b.jpg";